export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block2_Mobile-f9570d12018d8b63c27067e25fe06280.png";